import { render } from "./DocumentActions.vue?vue&type=template&id=0c3910b4&ts=true"
import script from "./DocumentActions.vue?vue&type=script&lang=ts"
export * from "./DocumentActions.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__